export default "__VITE_ASSET__DPghjuKZ__"